import React, { useState } from "react";
import Navbar from "../../commonComponents/Navbar";
import Footer from "../../commonComponents/Footer";
import RestrictionsFaq from "../../Componentsss/Restrictions/RestrictionsFaq/RestrictionsFaq";
import AboutTourism from "../../Componentsss/Tourism/AboutTourism/AboutTourism";
import OurTourismSolution from "../../Componentsss/Tourism/OurTourismService/OurTourismServices";
import ExploreTourism from "../../Componentsss/Tourism/ExploreTourism/ExploreTourism";
import YourSafetyAndWellBeing from "../../Componentsss/Tourism/YourSafetyAndWellBeing/YourSafetyAndWellBeing";
import Partnershipandaffiliations from "../../Componentsss/Tourism/PARTNERSHIP&AFFILIATIONS/Partnershipandaffiliations";
import BookYourNextAdventure from "../../Componentsss/Tourism/BookYourNextAdventure/BookYourNextAdventure";

const Tourism = () => {
  const [bannerLoaded, setBannerLoaded] = useState(false);

  return (
    <>
      <Navbar />
      <AboutTourism onLoad={() => setBannerLoaded(true)} />
      {bannerLoaded && (
        <>
          <OurTourismSolution />
          <ExploreTourism />
          <YourSafetyAndWellBeing />
          <Partnershipandaffiliations />
          <RestrictionsFaq />
          <BookYourNextAdventure />
          <Footer />
        </>
      )}
    </>
  );
};

export default Tourism;
